import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
  Row,
  Col,
  Input,
  CardBody,
  Card
} from "reactstrap";
import Tooltip from '@mui/material/Tooltip';

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";

import Alerts from "../../components/Alerts/alerts.js";

import ItemService from "./Item.service.js";
import AuthService from "../Authentication/auth.service.js";

import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import AlertService from "../../components/Alerts/alerts.js";

const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
`;

// const SmallImage = styled.img`
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   object-fit: cover;
//   transition: all 0.3s ease;
// `;
const SmallImage = styled.img`
  width: 40px; /* Increased from 30px */
  height: 40px; /* Increased from 30px */
  border-radius: 8px;
  object-fit: cover;
  transition: all 0.3s ease;
`;

const LargeImage = styled.img`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80%;
  max-height: 80%;
  z-index: 1000;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0,0,0,0.3);
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 999;
`;



const DriversList = () => {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const savedFilters = location.state?.filters;
  const [highlightId, setHighlightId] = useState(location.state?.highlightId || null);
  const [loading, setLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [Status, setStatus] = useState(savedFilters?.Status || '');
  const [Type, setType] = useState(savedFilters?.Type || '');
  const [Category, setCategory] = useState(savedFilters?.Category || '');
  const [Business, setBusiness] = useState(savedFilters?.Business || '');
  const [AllBusinesses, setAllBusinesses] = useState([]);
  const [AllCategories, setAllCategories] = useState([]);
  const [pageLimit, setPageLimit] = useState(savedFilters?.pageLimit || 10);
  const [currentPage, setCurrentPage] = useState(savedFilters?.currentPage || 1);
  const [searchName, setsearchName] = useState(savedFilters?.searchName || '');
  const [fieldlist, setfieldlist] = useState([]);

  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const placeholderImage = "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg";

  const ImageWithHover = ({ src, alt, placeholder }) => {
    const [showLarge, setShowLarge] = useState(false);
    const imageSrc = src || placeholder; // Use placeholder if src is not valid

    return (
      <ImageContainer
        onMouseEnter={() => setShowLarge(true)}
        onMouseLeave={() => setShowLarge(false)}
      >
        <SmallImage src={imageSrc} alt={alt} />
        {showLarge && src && src !== placeholder && ( // Prevent enlarging if using placeholder
          <LargeImage src={src} alt={alt} />
        )}
      </ImageContainer>
    );
  };




  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    if (savedFilters) {
      fetchData(savedFilters.currentPage || 1, savedFilters.pageLimit || 10, savedFilters);
      // Clear router state so a later Back doesn't re-apply stale filters/highlight
      navigate(location.pathname, { replace: true });
    } else {
      fetchData(1, pageLimit);
    }
  }, []);

  useEffect(() => {
    fetchCategories(0, 9999);
  }, []);

  const getListFilters = () => ({
    searchName,
    Status,
    Type,
    Category,
    Business,
    pageLimit,
    currentPage,
  });

  function fetchCategories(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = authData.userData;
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }

    var getData = {
      functionName: "GetCategoryDropDown",
      "postData": {
        "offset": offset,
        "sort": {
          "_id": -1
        },
        "limit": page_limit,
        business_id: business,
        "noActiveMatch": true
      }
    }
    setLoading(true);
    ItemService.GetCategories(getData, authData.sessionID,).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Category response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setAllCategories(response.data.data.data);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };
  function fetchData(page_index, page_limit, overrideFilters) {
    const effective = overrideFilters || { searchName, Status, Type, Category };
    var filter = {};
    if (effective.searchName !== "") {
      //iph todo: 47
      //console.log("Search name:-", effective.searchName)
      filter["name"] = effective.searchName
    }
    if (effective.Status !== "") {
      //iph todo: 47
      //console.log("Search Status:-", effective.Status)
      filter["status"] = effective.Status
    }
    if (effective.Type !== "") {
      //iph todo: 47
      //console.log("Search Type:-", effective.Type)
      filter["item_type"] = effective.Type
    }
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = JSON.parse(localStorage.getItem("user"));
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }
    let category = []
    if (effective.Category !== "") {
      category.push(effective.Category);
    }
    //iph todo: 47
    //console.log("category", category)
    var getData = {
      functionName: "GetItems",
      postData: {
        "sort": { _id: -1 },
        "offset": offset,
        "limit": page_limit,
        "filter": filter,
        "business": business,
        "category": category,
      },
    }
    setLoading(true);
    ItemService.getAllDrivers(getData, authData.sessionID).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Drivers response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setDrivers(response.data.data);
        setTotalRows(response.data.count.count);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };


  function fetchItems() {
    var getData = {
      functionName: "FetchItems",
    }
    setLoading(true);
    ItemService.FetchItems(getData).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Drivers response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        AlertService.swalSuccessAlert(response.data.message);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };


  function handlePageChange(page_index) {
    //iph todo: 47
    //console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchData(page_index, pageLimit);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
    fetchData(page_index, newPageLimit);
  }

  function nameFilter(e) {
    //iph todo: 47
    //console.log(e.target.value);
    setsearchName(e.target.value)
  }

  function resetFilters() {
    setResetPaginationToggle(!resetPaginationToggle);
    setsearchName('');
    setStatus('');
    setType('');
    setCategory('');
    setCurrentPage(1);
    var offset = 0;
    const stored_user = JSON.parse(localStorage.getItem("user"));
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }
    var getData = {
      functionName: "GetItems",
      postData: {
        "sort": { _id: -1 },
        "offset": offset,
        "limit": pageLimit,
        "filter": {},
        "business": business
      },
    }
    setLoading(true);
    ItemService.getAllDrivers(getData, authData.sessionID).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Drivers response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setDrivers(response.data.data);
        setTotalRows(response.data.count.count);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  }

  function searchItems() {
    setResetPaginationToggle(!resetPaginationToggle);
    setCurrentPage(1);
    fetchData(1, pageLimit);
  }


  function confirmDeleteItems(_id) {

    let msg = t("Once deleted, you will not be able to recover this Item!")
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendDelete(_id)
      }
    })
  };


  function sendDelete(id) {
    setLoading(true);
    ItemService.deleteDriver(id, authData.sessionID).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Delete Item response:-", response)
      if (response.data.status) {
        fetchData(0, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Item Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the driver at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };

  let mycolumns = [];

  mycolumns.push(
    {
      name: t("Code"),
      selector: row => row.item_code,
    },
    {
      name: t("Name"),
      width: '25%',
      selector: row => (
        <Tooltip title={row.item_name} arrow>
          <span style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{row.item_name}</span>
        </Tooltip>
      ),
    },
    {
      name: t("Image"),
      selector: (row) => (
        <ImageWithHover
          src={
            row?.index !== undefined &&
              row?.Images &&
              Array.isArray(row.Images) &&
              row.Images[row.index]
              ? row.Images[row.index]
              : row?.Images?.[0] || "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg"
          }
          alt={"No Image Available"}
        />
      ),
    },
    {
      name: t("Base UOM"),
      selector: row => row.BaseUOM,
    },
    {
      name: t("Price"),
      selector: row => parseFloat(row.price).toFixed(2),
    },
    {
      name: t('Status'),
      selector: (row) => {
        const handleStatusChange = async () => {
          const result = await Alerts.swalConfirmGeneralAlert(t("Do you want to change the status?"));
          if (result) {
            updateStatus(row._id, row.status);
          }
        };

        return (
          <button
            type="button"
            className={`btn btn-hover-shine me-3 btn ${row.status === "Active" ? "btn-success" : "btn-danger"}`}
            onClick={handleStatusChange}
          >
            {row.status}
          </button>
        );
      }
    },
    {
      name: t("Quantity"),
      selector: row => row.totalStockQuantity ? row.totalStockQuantity : 'N/A',
    },
  );

  mycolumns.push(
    {
      name: t('Actions'),
      selector: (row) => {
        return (
          <div>
            <button className="mt-2 mb-2 me-2 btn-icon btn">
              {!super_admin ? current_module?.ViewDetails === 1 &&
                <Tooltip placement="top" title={`${t("Item")} ${t("Details")}`} arrow>
                  <Link to="/item-details" state={row}>
                    <i className="pe-7s-note2 btn-icon-wrapper text-info"> </i>
                  </Link>
                </Tooltip >
                :
                <Tooltip placement="top" title={`${t("Item")} ${t("Details")}`} arrow>
                  <Link to="/item-details" state={row}>
                    <i className="pe-7s-note2 btn-icon-wrapper text-info"> </i>
                  </Link>
                </Tooltip >
              }
              {!super_admin ? current_module?.DeleteData === 1 &&
                <Tooltip placement="top" title="Delete" arrow>
                  <i onClick={() => confirmDeleteItems(row._id)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip >
                :
                <Tooltip placement="top" title="Delete" arrow>
                  <i onClick={() => confirmDeleteItems(row._id)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip >
              }
              {!super_admin ? current_module?.EditData === 1 &&
                <Tooltip placement="top" title="Edit" arrow>
                  <i>
                    <Link to="/update-Items" state={{ row, listFilters: getListFilters() }}>
                      <i className="pe-7s-pen btn-icon-wrapper text-primary"> </i>
                    </Link>
                  </i>
                </Tooltip >
                :
                <Tooltip placement="top" title="Edit" arrow>
                  <i>
                    <Link to="/update-Items" state={{ row, listFilters: getListFilters() }}>
                      <i className="pe-7s-pen btn-icon-wrapper text-primary"> </i>
                    </Link>
                  </i>
                </Tooltip >
              }
            </button>
          </div>
        );
      }
    }
  );
  //for search with enter keypress
  function checkenterkey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  const updateStatus = (_id, currentStatus) => {
    const updatedStatus = currentStatus === "Active" ? "Inactive" : "Active";

    const requestData = {
      _id: _id,
      functionName: "UpdateStatus",
      status: updatedStatus
    };

    setLoading(true);

    ItemService.UpdateStatus(requestData, authData.sessionID)
      .then((response) => {
        setLoading(false);
        if (response.data.status) {
          Alerts.swalSuccessAlert(response.data.message || t("Status updated successfully."));
          fetchData(currentPage, pageLimit);  // Refresh data
        } else {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            Alerts.swalErrorAlert(response.data.message || t("Error: Unable to update status."));
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Network operation failed."));
      });
  };


  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className=" bg-light-gray bg-animation ">
            <div className="d-flex  justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-users icon-gradient bg-tempting-azure" />
                      </div>
                      <div>
                        {t("Items Management")}
                        <div className="page-title-subheading">
                          {t('View all Items, Create, Edit and Delete an Item.')}.
                        </div>

                      </div>
                    </div>
                    <div className="page-title-actions">
                      <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                        {t("Back")}
                      </button>
                    </div>
                  </div>
                </div>
                <Row>
                  <Fragment>
                    <Row>
                      <Col md="12">
                        <Card className="main-card mb-3">
                          <CardBody>

                            <LoadingOverlay tag="div" active={loading}
                              styles={{ overlay: (base) => ({ ...base }) }}
                              spinner={<DNALoader />}>
                              <Row>

                                <Col md="2" >
                                  <Input
                                    type="text"
                                    name='name'
                                    value={searchName}
                                    placeholder='Search Text'
                                    onChange={(event) => nameFilter(event)}
                                  />
                                </Col>
                                <Col md="2">
                                  <Input
                                    type="select"
                                    style={{ borderColor: '#ccc' }}
                                    placeholder={t("Search Status")}
                                    value={Status}
                                    onChange={(e) => {
                                      //iph todo: 47
                                      //console.log(e.target.value);
                                      setStatus(e.target.value);
                                    }}
                                    handleKeyDown={(event) => checkenterkey(event)}
                                    id="colfilter"
                                  >

                                    <option disabled={false} value="">Select Status</option>
                                    <option key='Active' value='Active'>Active</option>
                                    <option key='Inactive' value='Inactive'>Inactive</option>
                                  </Input>
                                </Col>
                                {/* <Col md="2">
                                  <Input
                                    type="select"
                                    style={{ borderColor: '#ccc' }}
                                    placeholder={t("Search Type")}
                                    value={Type}
                                    onChange={(e) => {
                                      //iph todo: 47
                                      //console.log(e.target.value);
                                      setType(e.target.value);
                                    }}
                                    handleKeyDown={(event) => checkenterkey(event)}
                                    id="colfilter"
                                  >

                                    <option disabled={false} value="">Select Type</option>
                                    <option key='Service' value='Service'>Service</option>
                                    <option key='Goods' value='Goods'>Goods</option>
                                  </Input>
                                </Col> */}
                                {/* <Col md="2">
                                  <Input
                                    type="select"
                                    style={{ borderColor: '#ccc' }}
                                    placeholder={t("Search Business")}
                                    value={Business}
                                    onChange={(e) => {
                                      //iph todo: 47
                                      //console.log(e.target.value);
                                      setBusiness(e.target.value);
                                    }}
                                    handleKeyDown={(event) => checkenterkey(event)}
                                    id="colfilter"
                                  >
                                    <option disabled={false} value="">Select Business</option>
                                    {AllBusinesses &&
                                      AllBusinesses.map((Businesses, index) => (
                                        <option key={index} value={Businesses._id}>{Businesses.name}</option>
                                      ))
                                    }
                                  </Input>
                                </Col> */}
                                <Col md="2">
                                  <Input
                                    type="select"
                                    style={{ borderColor: '#ccc' }}
                                    placeholder={t("Search Category")}
                                    value={Category}
                                    onChange={(e) => {
                                      //iph todo: 47
                                      //console.log(e.target.value);
                                      setCategory(e.target.value);
                                    }}
                                    handleKeyDown={(event) => checkenterkey(event)}
                                    id="colfilter"
                                  >
                                    <option disabled={false} value="">Select Category</option>
                                    <option key={'POISON'} value={'POISON'}>Poison</option>
                                    <option key={'NP'} value={'NP'}>Non-poison</option>
                                    <option key={'DISPOSABLES'} value={'DISPOSABLES'}>Disposables</option>
                                    <option key={'CC POISON'} value={'CC POISON'}>CC Poison</option>
                                    {AllCategories?.filter(category => category.Name?.trim() !== "").map((category) => (
                                      <option key={category._id} value={category._id}>
                                        {category.Name}
                                      </option>
                                    ))}
                                  </Input>
                                </Col>
                                <Col md="3">
                                  <button type="button" className="btn btn-custom-color btn-hover-shine" onClick={() => searchItems()}>{t("Search")}</button>
                                  <button type="button" className="btn btn-custom-color btn-hover-shine ms-1" onClick={() => resetFilters()}>{t("Reset")}</button>
                                  {!super_admin ? current_module?.AddData === 1 &&
                                    <a href="/add-Items" className="btn btn-custom-color btn-hover-shine ms-1">
                                      {t("Add")}</a>
                                    :
                                    <a href="/add-Items" className="btn btn-custom-color btn-hover-shine ms-1">
                                      {t("Add")}</a>
                                  }
                                  {/* {!super_admin ? current_module?.FetchData === 1 && */}
                                  <button onClick={() => { fetchItems() }} className="btn btn-custom-color btn-hover-shine ms-1">
                                    {t("Fetch Items")}</button>
                                  {/* :
                                    <a href="/Fetch-Items" className="btn btn-custom-color btn-hover-shine ms-1">
                                      {t("Fetch Items")}</a> */}
                                  {/* } */}
                                </Col>
                              </Row>


                              <Col md="12" className="pt-3">
                                <DataTable
                                  data={drivers}
                                  columns={mycolumns}
                                  pagination
                                  fixedHeader
                                  fixedHeaderScrollHeight="400px"
                                  paginationServer
                                  paginationTotalRows={totalRows}
                                  paginationDefaultPage={currentPage}
                                  onChangePage={handlePageChange}
                                  onChangeRowsPerPage={handlePerRowsChange}
                                  paginationResetDefaultPage={resetPaginationToggle}
                                  conditionalRowStyles={[
                                    {
                                      when: (r) => highlightId && r._id === highlightId,
                                      style: { backgroundColor: '#fff7cd' },
                                    },
                                  ]}
                                />
                              </Col>

                            </LoadingOverlay>

                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Fragment>
                </Row>
              </Col>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

export default DriversList;